module.exports = __webpack_public_path__ + "static/media/tg1.32ac961e.jpg";